class PartyListRequest {
  shopId: string;

  constructor(shopId: string) {
    this.shopId = shopId;
  }
}

export default PartyListRequest;
